/**
 * P-10.9: which menus start a task, for the "Only from a menu button" card and the Check screen's
 * "No menu starts this task yet". Pure.
 *
 * A menu that is switched off starts nothing, so it does not count. A task not saved yet has no
 * id for an option to point at, so nothing starts it.
 *
 * @param {Array<{ title: string, enabled: boolean, options: Array<{ taskId: number|null }> }>} menus
 *   Menu details (`wasloApi.getMenu`).
 * @param {number|null} taskId
 * @returns {string[]} The titles, in the order given.
 */
export const menusStartingTask = (menus, taskId) => {
  if (taskId === null || taskId === undefined) return [];
  return (Array.isArray(menus) ? menus : [])
    .filter(
      menu =>
        menu?.enabled === true &&
        (menu.options ?? []).some(option => option?.taskId === taskId)
    )
    .map(menu => menu.title);
};

export default menusStartingTask;
